module.exports = __webpack_public_path__ + "static/headshot-c2ab93151be9d86a73b55f701a009679.jpg";